import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-layouts',
  templateUrl: './login-layouts.component.html',
  styleUrls: []
})
export class LoginLayoutsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
